export default "__VITE_ASSET__CKZ_ZGiI__"